// THIRD PARTY
setTimeout(() => AOS.init({
    disable: 'mobile'
}), 510);

let navigation = new Navigation;

[].forEach.call(document.querySelectorAll('.slider'), (slider) => new Slider(slider));
[].forEach.call(document.querySelectorAll('.toggle-link'), (toggleLink) => new Toggle(toggleLink));
[].forEach.call(document.querySelectorAll('.gmap'), (gmap) => new GoogleMaps(gmap));

